export default {
  methods: {

    // Actual field value based on original value, duplicate selections and manual overrides.
    fieldValue(fieldKey, overrideFields, selectedFields) {

      if (this.application[fieldKey] !== overrideFields[fieldKey]) {
        return overrideFields[fieldKey];
      }

      let value = this.application[fieldKey];

      this.duplicateIds.forEach((id) => {
        if (selectedFields[fieldKey].includes(id)) {
          value = this.duplicates[id][fieldKey];
          return false;
        }
      });

      return value;
    },

    // Convert value to empty string if it is null or undefined.
    normalizeValue(value) {

      if (value === null || value === undefined || value === '') {
        return '';
      }

      return value;
    },

    // Determine if attachment list is empty.
    attachmentsListIsEmpty(attachments) {

      return Object.keys(attachments).length === 0;
    },

    // Format bytes output.
    bytesFormatted(bytes) {
      bytes = parseInt(bytes);
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return '0 Byte';
      let i = Math.floor(Math.log(bytes) / Math.log(1024));
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },

    /**
     * Generate hash code of table object.
     *
     * @param table
     * @param keysToCompare
     *
     * @returns number
     */
    hashTable(table, keysToCompare) {
      return table.map(item => {
        let entryHash = 0;
        let keys = keysToCompare ?? Object.keys(item);
        keys.forEach(key => {
          entryHash += this.hashCode(`${item[key]}`);
        });
        return entryHash;
      }).reduce((total, num) => total + num, 0);
    },

    /**
     * Generate hash code of single string.
     *
     * @param str
     *
     * @returns number
     */
    hashCode(str) {
      let h = 0;
      for (let i = 0; i < str.length; i++)
        h = Math.imul(31, h) + str.charCodeAt(i) | 0;
      return h;
    },

  }
}
